// extracted by mini-css-extract-plugin
export default {"menu":"Navbar_menu__RhlpJ","logo":"Navbar_logo__MK0b0","homePage":"Navbar_homePage__weSVL","crearDog":"Navbar_crearDog__SXwna","h1":"Navbar_h1__Qwqth"};